import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { routes } from "./routing/routes";
import { useEffect, useState } from "react";
import { messaging } from "./firebase";
import toast from "react-hot-toast";
import { onMessage } from "firebase/messaging";
import { MdNotificationsActive } from "react-icons/md";
import notificationSound from "./assets/music/alert1.mp3";
import "./i18n";
import "./App.css";
import { useDispatch, useSelector } from "react-redux";
import { getAllAssignedTasks } from "./pages/Home/homeActions";
import { getStatus } from "./services/serviceActions";
import { getItemFromLocalStorage } from "./helpers/utils";
import Spinner from "./Components/Spinner";
import TripAssigned from "./pages/TripAssigned";
import { updateLivePing } from "./services/api/updatePing";
import { shifterTripSeenUpdate } from "./services/api/shifterSeenUpdate";
import { TRIP_STATUS } from "./helpers/constants";

const router = createBrowserRouter(routes);

export default function Root() {
  const { clubbed_trip: clubbedTrips = [] } = useSelector(
    (state) => state.home.tripDetails
  );

  const {
    shifter_type: shifterType = "",
    booking_request: { no_of_shifters: shifterCount = 1 } = {},
    status = "",
  } = clubbedTrips?.[0] || [];

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    onMessage(
      messaging,
      (payload) => {
        console.log(payload);
        if (payload.notification) {
          dispatch(getAllAssignedTasks());
          dispatch(getStatus());
          if (payload?.data?.notification_message_type === "new_trip") {
            dispatch(shifterTripSeenUpdate("delivered"));
          }
          playRingtone();
          toast.success(
            () => (
              <span>
                <b>{payload.notification?.title}</b>
                <br />
                <i>{payload.notification?.body}</i>
              </span>
            ),
            {
              duration: 6000,
              position: "top-center",
              icon: <MdNotificationsActive size={22} color="#2C4861" />,
            }
          );
        }
      },
      []
    );

    const handleVisibilityChange = async () => {
      if (
        document.visibilityState === "visible" &&
        getItemFromLocalStorage("isLoggedIn")
      ) {
        console.log(`App is in the foreground `);
        setLoading(true);
        await dispatch(getAllAssignedTasks());
        await dispatch(getStatus());
        setLoading(false);
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    const updateLive = () => {
      if (getItemFromLocalStorage("isLoggedIn")) {
        dispatch(updateLivePing());
      }
    };

    updateLive();
    const intervalId = setInterval(() => {
      updateLive();
    }, 60000);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    let taskIntervalId;
    if (
      shifterCount > 1 &&
      (status === TRIP_STATUS.SHIFTER_ASSIGNED || status === TRIP_STATUS.BOOKED)
    ) {
      taskIntervalId = setInterval(() => {
        dispatch(getAllAssignedTasks());
      }, 1000);
    }
    return () => {
      if (taskIntervalId) clearInterval(taskIntervalId);
    };
  }, [shifterCount, status]);

  useEffect(() => {
    let shiftIntervalId;

    if (
      shifterType === "secondary" &&
      status !== TRIP_STATUS.SHIFTER_ASSIGNED
    ) {
      shiftIntervalId = setInterval(() => {
        dispatch(getAllAssignedTasks());
        dispatch(getStatus());
      }, 10000);
    }
    return () => {
      if (shiftIntervalId) clearInterval(shiftIntervalId);
    };
  }, [shifterType, status]);

  const playRingtone = () => {
    const ringtone = new Audio(notificationSound);
    ringtone.play();

    setTimeout(() => {
      ringtone.pause();
      ringtone.currentTime = 0;
    }, 2000);
  };

  return (
    <div className="App">
      {loading && <Spinner />}
      {<TripAssigned />}
      <RouterProvider router={router} />
    </div>
  );
}
